module.exports = __webpack_public_path__ + "static/media/location-pin.62f45bc1.svg";